import React from 'react';
import styles from './BuildPlan.module.css';
import cn from 'classnames';

const SelectionCard = ({
    checked,
    type, // 'radio' or 'checkbox'
    title,
    icon,
    onClick
}) => {
    // code/logic/vars here

    return (
        <div
            onClick={onClick}
            className={cn(styles.categoryCard, checked && styles.checked)}
        >
            {icon && <div> {icon}</div>}
            {title}
            {type === 'checkbox' && (
                <div>
                    <input
                        type='checkbox'
                        checked={checked}
                    ></input>
                </div>
            )}
            {type === 'radio' && (
                <div>
                    <input
                        type='radio'
                        checked={checked}
                    ></input>
                </div>
            )}
        </div>
    );
};

export default SelectionCard;
